// extracted by mini-css-extract-plugin
export default {"tile":"resource_tile__DjOG1","tileLight":"resource_tileLight__dovmL","tileDark":"resource_tileDark__+gAIU","tileActive":"resource_tileActive__3vrvp"};